const GetOffersUrl = `/admin/api/offers`;
const GetOfferUrl = (offerId: number) => `/admin/api/offers/${offerId}`;
const PostOfferUrl = `/admin/api/offers/`;
const PutOfferUrl = (offerId: number) => `/admin/api/offers/${offerId}`;

export { GetOffersUrl, GetOfferUrl, PostOfferUrl, PutOfferUrl };